import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Work from "@/components/site/Work";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import Studio from "@/components/site/Studio";
import Pricing from "@/components/site/Pricing";
import AuthCallback from "@/components/site/AuthCallback";
import CustomCursor from "@/components/site/CustomCursor";
import IntroSplash from "@/components/site/IntroSplash";

const Landing = () => (
    <>
        <IntroSplash />
        <Nav />
        <main>
            <Hero />
            <Marquee />
            <Work />
            <Services />
            <Pricing />
            <About />
            <Contact />
        </main>
        <Footer />
    </>
);

const AppRouter = () => {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/studio" element={<Studio />} />
        </Routes>
    );
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App min-h-screen bg-mist font-sans text-ink antialiased">
            <BrowserRouter>
                <AppRouter />
            </BrowserRouter>
            <CustomCursor />
            <Toaster position="bottom-right" />
        </div>
    );
}

export default App;
